import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "col-lg-8" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "Upload Pdf for Digitization"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("small", null, "During Beta, as a thank you, the Convorally team will make all of your document templates interactive. We will generate your document link within 24 to 48 hours and notify you via email.")
  ])
], -1)
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = { class: "button-header text-lg-right upload-btn-wrap" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Upload Pdf ")
const _hoisted_11 = { class: "modal-wrap" }
const _hoisted_12 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_14 = { class: "modal-content  mh-auto" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("strong", null, "Successfully uploaded the PDF."),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("small", null, "During Beta, as a thank you, the Convorally team will make all of your document templates interactive. We will generate your document link within 24 to 48 hours and notify you via email.")
    ])
  ])
], -1)
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = { class: "modal-wrap" }
const _hoisted_21 = {
  class: "modal fade",
  id: "deleteConfirmeModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_22 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_23 = { class: "modal-content  mh-auto" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Delete Confirm "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center mb-0",
    role: "alert"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-check-circle mr-2" }),
    /*#__PURE__*/_createTextVNode(" Are you sure you want to delete ? ")
  ])
], -1)
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " No ", -1)
const _hoisted_28 = { class: "modal-wrap default-modal" }
const _hoisted_29 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "uploadFileInDocusign",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-header" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Upload Document "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Upload your document for digitize ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_35 = { class: "modal-body" }
const _hoisted_36 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  src: "https://localhost:8080//img/loading.gif",
  alt: ""
}, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "text-danger mb-3"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle mr-2" }, null, -1)
const _hoisted_40 = { class: "form-wrap pt-0" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Document Name", -1)
const _hoisted_43 = { class: "upload-btn-wrapper" }
const _hoisted_44 = /*#__PURE__*/_createVNode("button", {
  for: "formFileSm",
  class: "upload-btn btn default-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }),
  /*#__PURE__*/_createTextVNode(" Choose PDF")
], -1)
const _hoisted_45 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_47 = { class: "imaged-col" }
const _hoisted_48 = { class: "small-img-wrap" }
const _hoisted_49 = {
  key: 0,
  href: "javascript:void(0)",
  title: "click to rename"
}
const _hoisted_50 = { class: "size" }
const _hoisted_51 = { class: "remove-btn positioned-btn" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = {
  key: 1,
  class: "iframe",
  style: {"height":"800px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocusignDocumentListTable = _resolveComponent("DocusignDocumentListTable")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (!_ctx.state.ui.isLoading.showDocusignIframe && !_ctx.state.ui.isLoading.docuSignIframeEdit)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.state.ui.isLoading.clientDocumentList || _ctx.state.ui.isPostLoading.uploadClientDocument)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn d-inline-block",
                  id: "uploadPdfForDigitize",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showUploadDocusignDocument && _ctx.showUploadDocusignDocument(...args)))
                }, [
                  _hoisted_9,
                  _hoisted_10
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_DocusignDocumentListTable, {
          docs: _ctx.state.data.clientDocuments,
          heading: _ctx.state.data.hearder,
          from: _ctx.state.data.from
        }, null, 8, ["docs", "heading", "from"]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("h5", _hoisted_16, _toDisplayString(_ctx.state.data.selectDocument), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_17
                  ])
                ]),
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideResponseModal && _ctx.hideResponseModal(...args)))
                  }, " Close ")
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteDocument && _ctx.deleteDocument(...args)))
                  }, " Yes "),
                  _hoisted_27
                ])
              ])
            ])
          ])
        ]),
        (_ctx.state.data.showSuccesCustomModal)
          ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
              key: 1,
              onClose: _ctx.closeSuccessCustomModal,
              showModal: _ctx.state.data.showSuccesCustomModal,
              titleMessage: _ctx.state.data.successFulMessage
            }, null, 8, ["onClose", "showModal", "titleMessage"]))
          : _createCommentVNode("", true),
        (_ctx.state.ui.isActive.upgradeSubscription)
          ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
              key: 2,
              onCloseModal: _ctx.hideUpdateSubscriptionModal
            }, null, 8, ["onCloseModal"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideUploadDocusignDocument && _ctx.hideUploadDocusignDocument(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_34
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  (_ctx.state.ui.isPostLoading.templateCreating)
                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                        _hoisted_37
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.ui.error.errorList.fileValid)
                    ? (_openBlock(), _createBlock("p", _hoisted_38, [
                        _hoisted_39,
                        _createTextVNode(_toDisplayString(_ctx.state.ui.error.errorList.fileValid), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.error.errorList.createDocusignDocument,
                    hasError: _ctx.state.ui.error.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createVNode("input", {
                        type: "email",
                        class: "form-control",
                        id: "exampleInputFolderName",
                        "aria-describedby": "emailHelp",
                        placeholder: "eg.Team",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.documentName = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.documentName]
                      ])
                    ]),
                    _createVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode("input", {
                        type: "file",
                        multiple: "",
                        accept: "*.*",
                        id: "profileUpdate",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onDocumentChange($event)))
                      }, null, 32)
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imagesToUpload, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: imageIndex,
                        class: "shadowed-card bg-white mb-2 mt-2"
                      }, [
                        (image.isuploded)
                          ? (_openBlock(), _createBlock("div", _hoisted_45, [
                              _hoisted_46
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_47, [
                          _createVNode("div", _hoisted_48, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl
      ? `${_ctx.state.data.imageBaseUrl}img/pdf.png`
      : 'img/pdf.png'
    ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          (!image.isEdit)
                            ? (_openBlock(), _createBlock("a", _hoisted_49, [
                                _createVNode("h5", null, _toDisplayString(image.fileName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("p", _hoisted_50, _toDisplayString(image.size), 1)
                        ]),
                        _createVNode("div", _hoisted_51, [
                          _createVNode("a", {
                            title: "Delete",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                          }, [
                            _hoisted_52
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createTemplate && _ctx.createTemplate(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.templateCreating
      ? "Creating..."
      : "Upload Document"), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_54, [
        _createVNode("iframe", {
          id: "myIframe",
          src: _ctx.state.data.docuSignUrl ? _ctx.state.data.docuSignUrl : _ctx.state.data.docuSignSignEditUrl,
          name: "myFrame",
          frameborder: "0",
          scrolling: "no",
          style: {"position":"relative","height":"100%","width":"100%"}
        }, null, 8, ["src"])
      ]))
}